export default "__VITE_ASSET__CAelApJM__ 500w";